module.exports = __webpack_public_path__ + "media/media/product-card/vlsat_plus_empty-e5bc42a61bf54e269c5549ac4e767375.jpg";